import { HitApiType, ProjectAchievementApiType, ProjectAvailableApiType } from '@api/types';
import { HitType, ProjectAchievementType, ProjectType } from '@types';

export const projectApiMapper = (projectAvailableApi: ProjectAvailableApiType): ProjectType => {
  try {
    return {
      idProject: projectAvailableApi.idProject,
      name: projectAvailableApi.name,
      state: projectAvailableApi.state,
      isReviewProject: projectAvailableApi.isReviewProject,
      isAccessibleToUser: projectAvailableApi.isAccessibleToUser,
    };
  } catch (e) {
    throw e;
  }
};

export const projectAchievementApiMapper = (
  projectsAchievementApi: ProjectAchievementApiType,
): ProjectAchievementType => {
  try {
    return {
      idProject: projectsAchievementApi.idProject,
      name: projectsAchievementApi.name,
    };
  } catch (e) {
    throw e;
  }
};

export const hitAchievementApiMapper = (hitsAchievementApi: HitApiType): HitType => {
  try {
    return {
      idHit: hitsAchievementApi.idHit,
      supportDateTime: hitsAchievementApi.supportDateTime,
      projectName: hitsAchievementApi.task?.project?.name,
    };
  } catch (e) {
    throw e;
  }
};
